import { useEffect } from 'react';
import { ScrollRestoration } from 'react-router';
import { useLocation } from 'react-router';
import { useMatchesHandleData } from '~/modules/root/hook/use-matches-handle-data';
import { consumePendingRestoreAtTop, restorationKey } from './restore-at-top';

/**
 * A temporary solution until remix releases a version with react router 6.4.
 * Which we can then just use <Link preventScrollReset /> to do what this is doing here.
 *
 * Solution source: https://discord.com/channels/770287896669978684/1020648336304394280/1020786888568750130
 *
 */
const ConditionalScrollRestoration = () => {
    const location = useLocation();
    const disableScrollRestoration = useMatchesHandleData(
        'disableScrollRestoration',
        false,
    );

    // A link that hands over to the next listing leaves its departing key
    // behind rather than marking it on the spot, so that the router's own
    // save of that entry happens first. This is the next location: apply it.
    useEffect(() => {
        consumePendingRestoreAtTop(location.key);
    }, [location.key]);

    // Suppress when the current route manages its own scroll restoration
    if (disableScrollRestoration) {
        return null;
    }

    if (
        location.state != null &&
        typeof location.state === 'object' &&
        (location.state as { scroll: boolean }).scroll === false
    ) {
        return null;
    }

    // The key swap sends entries left through a next-listing turn back to
    // their top instead of the scroll clamp they were left at.
    return <ScrollRestoration getKey={restorationKey} />;
};

export default ConditionalScrollRestoration;
